<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    title="Будующие дни погрузи"
    width="90%"
    top="5vh"
    custom-class="map-dialog"
    @close="beforeClose"
  >
    <loader-wrapper :loading="isLoading">
      <el-row>
        <el-col :span="19">
          <drivers-y-map
            :bid="getBid"
            :cars="checkedCars"
            :coords="coords"
            :radio="radio"
            :search="search"
            :current="current"
          />
        </el-col>
        <el-col :span="5" class="map-right">
          <el-input
            v-model="search"
            placeholder="Поиск"
            clearable
            @input="checkField"
            @clear="onClear()"
          />
          <el-radio-group
            v-if="!search"
            v-model="radio"
            class="map-right-scroll"
          >
            <el-radio v-for="(day, i) in days" :key="day + i" :label="day">
              {{ day }}
            </el-radio>
          </el-radio-group>
          <section v-else class="map-right-scroll">
            <el-row
              v-for="car in filteredCars"
              :key="car.id"
              type="flex"
              align="middle"
            >
              <el-button
                type="text"
                :icon="getIcon(car.id)"
                :class="{ green: current === car.id }"
                @click="setCurrent(car.id)"
              >
                {{ car.num }}
              </el-button>
              <loader-wrapper :loading="isLoading" spinner="el-icon-loading">
                {{ getCoord(coords[car.id]) }}
              </loader-wrapper>
            </el-row>
          </section>
        </el-col>
      </el-row>
    </loader-wrapper>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { getNow } from '@/helpers/date'
import { mapActions, mapGetters } from 'vuex'
import { shortDateWithoutYear } from '@/datas/DateFormats'
import DriversYMap from '@/components/Maps/DriversYMap'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

const RespAPI = RepositoryFactory.get('responses')

export default {
  name: 'BidOnMap',
  components: { DriversYMap, LoaderWrapper },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: '',
      current: '',
      radio: '',
      loading: false,
      coords: {},
      days: [],
      cars: [],
    }
  },
  computed: {
    ...mapGetters('bids', ['getLoading', 'getBid']),
    isLoading() {
      return this.getLoading('Map') || this.loading
    },
    checkedCars() {
      const { radio, cars, current } = this

      return current
        ? [cars.find(c => c.id === current)]
        : cars.filter(c => c[radio])
    },
    filteredCars() {
      const { search, cars } = this

      return search
        ? cars.filter(c => c.num.includes(search.toUpperCase()))
        : []
    },
  },
  watch: {
    id: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.visible) {
          this.fetchBidForMap(newVal)
          this.getCoords(newVal)
        }
      },
    },
    getBid(val) {
      if (val['load-days'] && !this.radio) {
        this.getInfo(val['load-days'])
        this.onClear()
      }
    },
  },
  methods: {
    ...mapActions('bids', ['fetchBidForMap']),
    getInfo(ld) {
      const obj = {}
      const days = []

      ld.map(d => {
        if (d.responses.length) {
          const day = this.dateToFormat(d.load_date, 'shortDateWithoutYear')

          days.push(day)
          d.responses.map(c => {
            const { id, state_numbers: num } = c.automobile

            if (!obj[id]) {
              obj[id] = { id, num }
            }
            obj[id][day] = true
          })
        }
      })
      this.cars = Object.values(obj)

      if (!this.cars.length && !this.isLoading && this.visible) {
        this.beforeClose()
        this.$message.warning('Нет машин для отображения')
      }
      this.days = days
    },
    setCurrent(num = '') {
      this.current = num
      this.radio = ''
    },
    checkField(val) {
      if (!val) {
        this.onClear()
      }
    },
    onClear() {
      this.setCurrent()
      this.radio = getNow(shortDateWithoutYear)
    },
    getIcon(id) {
      return this.current === id ? 'el-icon-s-promotion' : 'el-icon-position'
    },
    getCoords(bid_id) {
      this.loading = true
      RespAPI.getCoords({ bid_id })
        .then(({ data }) => this.getCoordsObj(data))
        .catch(err => this.errHandler(err))
        .finally(() => (this.loading = false))
    },
    getCoordsObj(data) {
      const obj = {}

      if (data && data.items) {
        data.items.map(b => (obj[b.automobile_id] = b.coords))
      }
      this.coords = obj
    },
    getCoord(data) {
      const date =
        data && data.date
          ? ' - ' + this.dateToFormat(data.date, 'respStatusDate')
          : ''

      return !data && !this.isLoading ? '- нет координат' : date
    },
    beforeClose() {
      this.$emit('closed')
      this.search = ''
      this.radio = ''
      this.current = ''
    },
  },
}
</script>

<style lang="sass">
.map-dialog
  overflow: hidden
  height: 100%
  .map-right
    padding: 0 0 0 20px
    .map-right-scroll
      height: 70vh
      overflow-y: auto
      display: flex
      flex-direction: column
      .el-radio
        margin-top: 15px
    .el-button
      margin-right: 5px
      &.green
        color: #67c23a
</style>
